var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTaskPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.8594,
    r: 12.5,
    fill: "#FAF3B3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1244)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23891 17.5471C8.12589 17.5471 8.0175 17.5022 7.93758 17.4223C7.85767 17.3424 7.81277 17.234 7.81277 17.121V8.59822C7.81277 8.4852 7.85767 8.37681 7.93758 8.2969C8.0175 8.21698 8.12589 8.17209 8.23891 8.17209L17.1878 8.17209H17.827C17.9965 8.17209 18.1591 8.10474 18.279 7.98487C18.3988 7.86499 18.4662 7.70241 18.4662 7.53288C18.4662 7.36335 18.3988 7.20077 18.279 7.0809C18.1591 6.96102 17.9965 6.89368 17.827 6.89368L8.23891 6.89368C7.78683 6.89368 7.35328 7.07326 7.03361 7.39293C6.71395 7.71259 6.53436 8.14615 6.53436 8.59822V17.121C6.53436 17.573 6.71395 18.0066 7.03361 18.3262C7.35328 18.6459 7.78683 18.8255 8.23891 18.8255H16.7616C17.2137 18.8255 17.6473 18.6459 17.9669 18.3262C18.2866 18.0066 18.4662 17.573 18.4662 17.121V7.53288C18.4662 7.36335 18.3988 7.20077 18.279 7.0809C18.1591 6.96102 17.9965 6.89368 17.827 6.89368C17.6574 6.89368 17.4949 6.96102 17.375 7.0809C17.2551 7.20077 17.1878 7.36335 17.1878 7.53288V8.17209V17.121C17.1878 17.234 17.1429 17.3424 17.063 17.4223C16.983 17.5022 16.8747 17.5471 16.7616 17.5471H8.23891Z",
    fill: "#F0C014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1878 8.17209H17.827C17.9965 8.17209 18.1591 8.10474 18.279 7.98487C18.3988 7.86499 18.4662 7.70241 18.4662 7.53288C18.4662 7.36335 18.3988 7.20077 18.279 7.0809C18.1591 6.96102 17.9965 6.89368 17.827 6.89368C17.6574 6.89368 17.4949 6.96102 17.375 7.0809C17.2551 7.20077 17.1878 7.36335 17.1878 7.53288V8.17209Z",
    fill: "#F0C014"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.6364,
    height: 13.6364,
    fill: "white",
    transform: "translate(5.68182 6.04114)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTaskPending);
export default __webpack_public_path__ + "static/media/icon-task-pending.8d74d4ce283d49db5a46e77fc506cee9.svg";
export { ForwardRef as ReactComponent };